import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserEditContainerComponent} from './containers/settings/user-edit-container.component';
import {SharedModule} from '../shared/shared.module';
import {ImageUploadModule} from '../shared/image-upload/image-upload.module';
import {JwBootstrapSwitchNg2Module} from 'jw-bootstrap-switch-ng2';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TagInputModule} from 'ngx-chips';
import {StoreModule} from '@ngrx/store';
import * as userReducer from './state/users.reducer';
import {EffectsModule} from '@ngrx/effects';
import {UserEffects} from './state/users.effects';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {UserProfileContainerComponent} from './containers/user-profile/user-profile-container.component';
import {NgbCarouselModule, NgbTabsetModule} from '@ng-bootstrap/ng-bootstrap';
import {RouterModule} from '@angular/router';
import {UserCardComponent} from './components/user-card/user-card.component';
import {PortfolioEditComponent} from './components/portfolio-edit/portfolio-edit.component';
import { GalleryModule} from '@ngx-gallery/core';
import {LightboxModule} from '@ngx-gallery/lightbox';
import {GallerizeModule} from '@ngx-gallery/gallerize';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {UserPortfolioEditContainerComponent} from './containers/portfolio/user-portfolio-edit/user-portfolio-edit-container.component';
import {UserPortfolioOneContainerComponent} from './containers/portfolio/user-portfolio-one-container/user-portfolio-one-container.component';
import {UserGalleryComponent} from './components/gallery/user-gallery.component';
import {QuillConfig, QuillModule} from 'ngx-quill';
import { PortfolioBaseComponent } from './containers/portfolio/portfolio-base/portfolio-base.component';
import { UserPortfolioTwoContainerComponent } from './containers/portfolio/user-portfolio-two-container/user-portfolio-two-container.component';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  ['blockquote'],

  [{ header: 1 }, { header: 2 }],               // custom button values
  [{ list: 'ordered'}, { list: 'bullet' }],
  [{ indent: '-1'}, { indent: '+1' }],          // outdent/indent

  [{ size: ['small', 'normal', 'large'    ] }],  // custom dropdown
  // [{ header: [1, 2, 3, 4, 5, 6, false] }],

  // [{ color: [] }, { background: [] }],          // dropdown with defaults from theme
  // [{ font: [] }],
  [{ align: [] }],

];
const quilConfig: QuillConfig = {
  debug: 'error',
  modules: {
    toolbar: toolbarOptions
  },
  theme: 'snow'
};


@NgModule({
  declarations: [
    UserEditContainerComponent,
    UserProfileContainerComponent,
    UserCardComponent,
    PortfolioEditComponent,
    UserPortfolioEditContainerComponent,
    UserPortfolioOneContainerComponent,
    UserGalleryComponent,
    PortfolioBaseComponent,
    UserPortfolioTwoContainerComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    TagInputModule,
    SharedModule,
    NgbTabsetModule,
    NgbCarouselModule,
    RouterModule,
    ImageUploadModule,
    QuillModule.forRoot(quilConfig),
    GalleryModule.withConfig({loadingMode: 'indeterminate', counter: false}),
    LightboxModule.withConfig({
      panelClass: 'fullscreen'
    }),
    GallerizeModule,
    BrowserAnimationsModule,
    JwBootstrapSwitchNg2Module,
    StoreModule.forFeature('user', userReducer.reducer),
    EffectsModule.forFeature([UserEffects]),
    FormsModule,
    AngularMultiSelectModule
  ],
  exports: [
    UserEditContainerComponent, UserCardComponent
  ]
})
export class UserModule { }
